<template>
  <div class="cb-body__wrap">
    <div class="cb-body__content">
      <div class="cb-section">
        <div class="cb-options" :class="{'cb-options--active': payment_method.id == payment_source_id}" v-for="(payment_method, index) in payment_method_list" :key='index' @click="setPaymentMethod(payment_method.id)" v-cb-link="'shadow'" role="radiobutton">
          <div class="cb-options__group">
            <div class="cb-options__left">
              <div class="cb-options__radio" :style="payment_method.id == payment_source_id && backgroundColor">
                <i class="icon-check cb-options__icon" aria-hidden="true"></i>
              </div>
            </div>
            <div class="cb-options__right">
              <payment-method-summary :persistent-payment-method='payment_method'></payment-method-summary>
            </div>
          </div>
        </div>
      </div>
      <div class="cb-section--md">
        <div class="cb-section__link cb-section__center" v-cb-link = "'color'" data-cb-id="paynow_add_payment" @click="navigate('add_pm')">{{t('modal.newpm.use')}}
        </div>
      </div>
    </div>
    <div class="cb-body__footer cb-body__footer--text">
      <cb-notes v-if="canShowMandateText" slot="notes" :custom-class="'cb-section'" :type="'warning'" :message="eMandateTxt"></cb-notes>
      <checkout-subscribe :show-loader="showLoader" @submit="collectWithExistingPaymentSource()" :txt-key="'button.txt'" :total="amountToBePaid">
      </checkout-subscribe>
    </div>
    <cb-notes v-if="show3dsWarning" slot="notes" class="cb-notebar--footer" :type="'muted'" :message="t('threeds.warning')"> </cb-notes>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import PaymentMethodSummary from "@/components/modules/hosted-pages/PaymentMethodSummary"
import ButtonField from "@/components/collections/form/ButtonComponent"
import CheckoutSubscribeComponent from "@/components/modules/hosted-pages/CheckoutSubscribeButton"
import PaymentMixin from "@/mixins/payment-mixin"
import Notes from "@/components/collections/elements/Notes"
import { threedsNeeded } from "@/components/modules/hosted-pages/LazyLoadPaymentComponents"


export default {
  data() {
    return {
      payment_source_id: undefined,
      subDataDisplay: undefined,
      showLoader: false
    }
  },
  mixins: [PaymentMixin],
  methods: {
    setPaymentMethod(payment_source_id) {
      this.payment_source_id = payment_source_id;
    },
    navigate(section) {
      this.$router.push({
        name: section,
        query: {
          mode: 'edit'
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      'payment_method_list',
      'primary_pm',
      'amountToBePaid',
      'canAdd'
    ]),
    payment_method() {
      return this.payment_method_list.filter(({
        id
      }) => id == this.payment_source_id)[0];
    },
    show3dsWarning() {
      return this.payment_method && threedsNeeded(this.payment_method.gateway_account_id, this.payment_method.type, this.payment_method);
    },
    canShowMandateText() {
      return this.$store.getters.pm_by_mandate_enabled && this.isSingleleSubInvoiceSelected();
    },
    eMandateTxt() {
      return 'For cards issued in India, an e-mandate will be set up to automate recurring payments for this subscription. The mandate specifies broad terms so variations in the recurring charge (amount or frequency) do not require your manual confirmation. You will only be charged according to the plan you subscribe to.'
    }
  },
  components: {
    'payment-method-summary': PaymentMethodSummary,
    "cb-button": ButtonField,
    'checkout-subscribe': CheckoutSubscribeComponent,
    'cb-notes': Notes
  },
  mounted(){
    if (this.payment_method_list.length == 0) {
      this.$router.customReplace({name: "add_pm"});
    }
    this.primary_pm && this.setPaymentMethod(this.primary_pm.id);
  }
}
</script>
